import { t } from '../../app/i18n';

export default {
  SIGN_CONTRACT: 'SIGN_CONTRACT',
  SIGN_INSURANCE_CONTRACT: 'SIGN_INSURANCE_CONTRACT',
  ENTER_SMS_CODE_CONTRACT: 'ENTER_SMS_CODE_CONTRACT',
  WAIT_FOR_CONFIRMATION: 'WAIT_FOR_CONFIRMATION',
  SIGN_CONTRACT_WITH_INSURANCE: 'SIGN_CONTRACT_WITH_INSURANCE',
  ENTER_SMS_CODE_INSURANCE_CONTRACT: 'ENTER_SMS_CODE_INSURANCE_CONTRACT',
  UPLOAD_BANK_ACCOUNT_STATEMENTS: 'UPLOAD_BANK_ACCOUNT_STATEMENTS',
  SIGN_INFO_OBLIGATIONS: 'SIGN_INFO_OBLIGATIONS',
  ENTER_SMS_CODE_INFO_OBLIGATIONS: 'ENTER_SMS_CODE_INFO_OBLIGATIONS',
};

export const translation = {
  SIGN_CONTRACT: t(
    'Gratulujeme stali ste sa používateľom portálu Maják.sk, pre získanie pôžičky prosím potvrďte Záväznú žiadosť o pôžičku.'
  ),
  SIGN_CONTRACT_WITH_INSURANCE: t(
    'Gratulujeme stali ste sa používateľom portálu Maják.sk, pre získanie pôžičky prosím potvrďte Záväznú žiadosť o pôžičku a Žiadosť o zabezpečenie poistenia.'
  ),
  SIGN_INSURANCE_CONTRACT: t('Pre začatie čerpania pôžičky prosím potvrďte zmluvu o poistení.'),
  ENTER_SMS_CODE_CONTRACT: t('Zadajte SMS kód pre potvrdenie'),
  ENTER_SMS_CODE_INSURANCE_CONTRACT: t('Zadajte SMS kód pre potvrdenie zmluvy o poistení'),
  WAIT_FOR_CONFIRMATION: t('Čaká sa na zaradenie do Systému hľadania investorov'),
  UPLOAD_BANK_ACCOUNT_STATEMENTS: t('Nahrajte výpisy z bankového účtu a výplatné pásky za posledné dva mesiace'),
  SIGN_INFO_OBLIGATIONS: t('Pred podpisom žiadosti je potrebné podpísať Informačné povinnosti poskytovateľa služieb.'),
  ENTER_SMS_CODE_INFO_OBLIGATIONS: t('Zadajte SMS kód pre potvrdenie Informačných povinností'),
};



// WEBPACK FOOTER //
// ./src/common/enums/loanActions.js